var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableView24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "default__Category=Default, Type=Table view, State=Enabled, Size=24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "default__Vector",
    fill: "inherit",
    d: "M7.349 5.086a1 1 0 0 1 1-1H20.84a1 1 0 0 1 1 1v1.66a1 1 0 0 1-1 1H8.349a1 1 0 0 1-1-1v-1.66Zm-1.529 0a1 1 0 0 0-1-1H3.16a1 1 0 0 0-1 1v1.66a1 1 0 0 0 1 1h1.66a1 1 0 0 0 1-1v-1.66Zm1.529 6.672a1 1 0 0 1 1-1H20.84a1 1 0 0 1 1 1v1.66a1 1 0 0 1-1 1H8.349a1 1 0 0 1-1-1v-1.66Zm-1.529 0a1 1 0 0 0-1-1H3.16a1 1 0 0 0-1 1v1.66a1 1 0 0 0 1 1h1.66a1 1 0 0 0 1-1v-1.66Zm1.529 6.668a1 1 0 0 1 1-1H20.84a1 1 0 0 1 1 1v1.66a1 1 0 0 1-1 1H8.349a1 1 0 0 1-1-1v-1.66Zm-1.529 0a1 1 0 0 0-1-1H3.16a1 1 0 0 0-1 1v1.66a1 1 0 0 0 1 1h1.66a1 1 0 0 0 1-1v-1.66Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableView24);
export default __webpack_public_path__ + "static/media/table_view_24.f0809899cb022e65e6a8e6651c407c4b.svg";
export { ForwardRef as ReactComponent };